import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=0008c8f2&scoped=true"
import script from "./EditDate.vue?vue&type=script&lang=js"
export * from "./EditDate.vue?vue&type=script&lang=js"
import style0 from "./EditDate.vue?vue&type=style&index=0&id=0008c8f2&prod&lang=scss&scoped=true"
import style1 from "./EditDate.vue?vue&type=style&index=1&id=0008c8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008c8f2",
  null
  
)

export default component.exports